module.exports = __webpack_public_path__ + "static/media/advertisers_section2.4898e95d.png";